/*    
<summary>
   This typescript file contains special datatype that enables for a variale to be set of predefined enums.
   This enum is used to differentiate user types in the overall application.
   Developer: Mohammad Saquib Khan, Created Date: 08-Feb-2026
</summary>
*/
enum FontTypeEnum {
  Arial = 0,
  Meiryo = 1,
  "MS Mincho" = 2,
}

export default FontTypeEnum